import type { QueryClient } from '@tanstack/react-query';

import { queryKeys } from '~/utils/queryKeys';

export async function gapFillChatOnReconnect(
    chatId: string,
    after: number | null | undefined,
    deps: {
        fetchGap: (chatId: string, after: number, limit: number) => Promise<unknown[]>;
        invalidateChat: () => void;
        limit: number;
        mergeGap: (gapMessages: unknown[]) => void;
        queryClient: QueryClient;
    },
): Promise<void> {
    if (after == null) {
        deps.invalidateChat();
        return;
    }

    try {
        const gapMessages = await deps.fetchGap(chatId, after, deps.limit);

        // Full page means the gap may exceed one page — fall back to a full resync.
        if (gapMessages.length === deps.limit) {
            deps.invalidateChat();
            return;
        }

        deps.mergeGap(gapMessages);
    } catch {
        deps.invalidateChat();
        return;
    }

    deps.queryClient.invalidateQueries({ queryKey: queryKeys.getChats() });
}
